import { createSlice } from '@reduxjs/toolkit';
import { findSelectAddOnProduct, searchSelectAddOnProduct, getSelectAddOnProduct } from './api';
import { initialState } from './api/interface';

const selectAddOnProductSlice = createSlice({
  name: 'selectAddOnProduct',
  initialState,
  reducers: {
    setSkip: (state, action) => {
      state.skip = action.payload.skip;
    },
    setHasMoreToFalse: (state, action) => {
      state.hasMore = action.payload.hasMore;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(findSelectAddOnProduct.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(findSelectAddOnProduct.fulfilled, (state, action) => {
      // state.data.push(...action.payload.data);
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(findSelectAddOnProduct.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(searchSelectAddOnProduct.pending, (state) => {
      state.isLoading = true;
      state.status = 'pending';
    });
    builder.addCase(searchSelectAddOnProduct.fulfilled, (state, action) => {
      state.data = action.payload.data;
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
      state.status = 'succeeded';
      state.hasMore = action.payload.data.length < 10 ? false : true;
    });
    builder.addCase(searchSelectAddOnProduct.rejected, (state, _) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
      state.status = 'failed';
    });
    builder.addCase(getSelectAddOnProduct.pending, (state) => {
      state.isLoading = true;
    });
    builder.addCase(getSelectAddOnProduct.fulfilled, (state, _) => {
      state.isError = false;
      state.isSuccess = true;
      state.isLoading = false;
    });
    builder.addCase(getSelectAddOnProduct.rejected, (state) => {
      state.isLoading = false;
      state.isError = true;
      state.isSuccess = false;
    });
  },
});

export const { setSkip, setHasMoreToFalse, setStatus, reset } =
  selectAddOnProductSlice.actions;
export default selectAddOnProductSlice.reducer;
